export const mediaItems = [
  {
    id: 1,
    title: '下拉式阅读体验演示',
    desc: '连续滚动无缝加载，告别翻页等待',
    thumbnail: 'https://readdy.ai/api/search-image?query=Digital%20manga%20reading%20interface%20with%20continuous%20scroll%20design%2C%20Japanese%20comic%20page%20flowing%20vertically%20on%20a%20warm%20toned%20screen%2C%20minimalist%20UI%20with%20soft%20orange%20and%20cream%20accents%2C%20clean%20reading%20experience%20aesthetic%2C%20editorial%20quality%20with%20soft%20lighting&width=640&height=360&seq=media-manga-01&orientation=landscape',
    duration: '03:25',
    views: '128.6万',
  },
  {
    id: 2,
    title: '热门连载滚动畅读',
    desc: '多部人气漫画持续更新，一滚到底',
    thumbnail: 'https://readdy.ai/api/search-image?query=Vibrant%20manga%20panels%20arranged%20in%20a%20scrolling%20phone%20screen%20mockup%2C%20colorful%20Japanese%20comic%20art%20style%2C%20warm%20ambient%20background%20with%20soft%20gradients%2C%20modern%20reading%20app%20interface%2C%20clean%20composition%2C%20editorial%20photography&width=640&height=360&seq=media-manga-02&orientation=landscape',
    duration: '05:18',
    views: '96.3万',
  },
  {
    id: 3,
    title: '全集缓存离线爽看',
    desc: '预加载技术，地铁通勤也能流畅阅读',
    thumbnail: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20manga%20comic%20with%20download%20progress%20indicator%2C%20warm%20cozy%20background%20with%20soft%20ambient%20light%2C%20Japanese%20illustration%20style%2C%20clean%20modern%20interface%20design%2C%20orange%20and%20cream%20color%20palette%2C%20editorial%20quality&width=640&height=360&seq=media-manga-03&orientation=landscape',
    duration: '02:50',
    views: '85.7万',
  },
  {
    id: 4,
    title: '跨设备无缝同步进度',
    desc: '手机、平板、电脑随时切换阅读位置',
    thumbnail: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20showing%20synchronized%20manga%20reading%20progress%2C%20laptop%20tablet%20and%20phone%20displaying%20same%20comic%20page%2C%20warm%20neutral%20background%2C%20soft%20lighting%2C%20modern%20clean%20aesthetic%2C%20orange%20and%20cream%20tones&width=640&height=360&seq=media-manga-04&orientation=landscape',
    duration: '04:12',
    views: '72.4万',
  },
];

export const aboutInfo = {
  title: '汗汗漫画 · 重新定义阅读方式',
  content: '汗汗漫画诞生于对漫画阅读体验的极致追求。我们相信，翻页不应该成为打断沉浸感的障碍——下拉式连续阅读，才是漫画该有的样子。平台汇聚了热血、恋爱、悬疑、搞笑、奇幻等多元题材，每日更新上百话热门连载，覆盖国内外优质漫画资源。无论你是追更党还是补番族，汗汗漫画的下拉滚动体验都能让你一气呵成、畅读到底。',
  highlights: ['日更百话', '免费畅读', '智能缓存', '跨端同步'],
};

export const carouselItems = [
  {
    id: 1,
    title: '热血战斗 · 燃爆夏日',
    subtitle: '年度最强格斗漫画合集',
    desc: '从经典名作到新锐爆款，精选30部让人肾上腺素飙升的热血战斗漫画，下拉滚动一口气看到爽！',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20illustration%20with%20explosive%20energy%20effects%2C%20Japanese%20shonen%20style%20art%2C%20warm%20orange%20and%20red%20accents%2C%20clean%20composition%20on%20cream%20background%2C%20editorial%20quality%2C%20soft%20lighting&width=600&height=400&seq=carousel-manga-01&orientation=landscape',
    tag: '热血',
  },
  {
    id: 2,
    title: '恋爱甜宠 · 心动信号',
    subtitle: '不容错过的少女漫精选',
    desc: '心跳加速的甜蜜故事，从校园到职场，每一页都是青春的悸动。下拉连续阅读，甜度加倍！',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20with%20soft%20pastel%20tones%2C%20Japanese%20shojo%20style%20couple%20scene%2C%20cherry%20blossom%20elements%2C%20warm%20cream%20background%2C%20gentle%20lighting%2C%20clean%20editorial%20composition&width=600&height=400&seq=carousel-manga-02&orientation=landscape',
    tag: '恋爱',
  },
  {
    id: 3,
    title: '悬疑推理 · 烧脑剧场',
    subtitle: '高智商对决与反转剧情',
    desc: '层层递进的悬疑叙事，每一个分镜都暗藏线索。下拉滚动时，节奏由你掌控，推理不停歇！',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20illustration%20with%20dramatic%20shadow%20play%2C%20Japanese%20seinen%20style%20detective%20scene%2C%20warm%20dark%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20clean%20composition%2C%20editorial%20quality&width=600&height=400&seq=carousel-manga-03&orientation=landscape',
    tag: '悬疑',
  },
  {
    id: 4,
    title: '搞笑日常 · 快乐源泉',
    subtitle: '笑到停不下来的喜剧漫画',
    desc: '从沙雕日常到无厘头冒险，每翻一页都是表情包素材。下拉连续看，笑点密集不间断！',
    image: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20manga%20illustration%20with%20exaggerated%20expressions%2C%20Japanese%20gag%20style%20art%2C%20bright%20warm%20colors%2C%20cream%20background%2C%20playful%20composition%2C%20soft%20lighting%2C%20editorial%20quality&width=600&height=400&seq=carousel-manga-04&orientation=landscape',
    tag: '搞笑',
  },
  {
    id: 5,
    title: '奇幻异世 · 冒险启程',
    subtitle: '异世界与魔法题材大赏',
    desc: '从转生异世界到魔法学院，每一部都是想象力的大餐。下拉滚动间，世界在眼前展开！',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20manga%20illustration%20with%20magical%20elements%2C%20Japanese%20isekai%20style%20epic%20scene%2C%20warm%20golden%20and%20amber%20tones%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20editorial%20quality%2C%20soft%20lighting&width=600&height=400&seq=carousel-manga-05&orientation=landscape',
    tag: '奇幻',
  },
];

export const updateItems = [
  { id: 1, date: '2026-07-28', title: '《星界旅人》第203话更新上线', tag: '最新', type: 'update' },
  { id: 2, date: '2026-07-28', title: '《暗影猎手》第89话 · 限时免费阅读', tag: '限免', type: 'event' },
  { id: 3, date: '2026-07-27', title: '新作《苍穹之下》正式入驻汗汗漫画', tag: '新作', type: 'new' },
  { id: 4, date: '2026-07-27', title: '《恋爱这件小事》番外篇独家首发热度破百万', tag: '独家', type: 'event' },
  { id: 5, date: '2026-07-26', title: '夏季阅读季活动开启 · 签到领阅读时长', tag: '活动', type: 'event' },
  { id: 6, date: '2026-07-25', title: '《机械纪元》第156话 · 剧情反转引爆讨论', tag: '热话', type: 'update' },
  { id: 7, date: '2026-07-24', title: '阅读器2.0版本上线 · 下拉体验全面优化', tag: '升级', type: 'event' },
];

export const commentItems = [
  {
    id: 1,
    name: '漫迷小枫',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20person%2C%20warm%20orange%20tones%2C%20soft%20lighting%2C%20minimalist%20Japanese%20illustration%20style%2C%20clean%20background&width=80&height=80&seq=avatar-manga-01&orientation=squarish',
    content: '终于找到不用翻页的漫画站了！下拉阅读太爽了，看《星界旅人》一口气刷了50话，完全停不下来。加载速度也很快，推荐给所有追漫的朋友！',
    time: '2小时前',
    likes: 2386,
  },
  {
    id: 2,
    name: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20with%20glasses%2C%20warm%20coral%20tones%2C%20soft%20lighting%2C%20Japanese%20illustration%20style%2C%20clean%20minimalist%20background&width=80&height=80&seq=avatar-manga-02&orientation=squarish',
    content: '习惯了汗汗漫画的下拉模式之后，再也回不去那种翻页的阅读方式了。尤其是看战斗场面，连续滚动让打斗分镜的节奏感完美呈现，体验感直接拉满！',
    time: '5小时前',
    likes: 1853,
  },
  {
    id: 3,
    name: '二次元原住民',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20with%20energetic%20expression%2C%20warm%20amber%20tones%2C%20soft%20lighting%2C%20Japanese%20illustration%20style%2C%20clean%20background&width=80&height=80&seq=avatar-manga-03&orientation=squarish',
    content: '资源真的很全！我之前在好几个平台追的漫画，这里基本都能找到。而且全集缓存功能太适合我这个地铁通勤党了，信号不好的地方照样流畅看。',
    time: '1天前',
    likes: 1542,
  },
  {
    id: 4,
    name: '漫画鉴赏家',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20with%20sophisticated%20look%2C%20warm%20terracotta%20tones%2C%20soft%20lighting%2C%20Japanese%20illustration%20style%2C%20clean%20background&width=80&height=80&seq=avatar-manga-04&orientation=squarish',
    content: '作为一个看了十几年漫画的老读者，汗汗漫画的下拉阅读设计确实是用心了的。字体渲染清晰，图片加载优化得很好，跨设备同步也很方便，必须给个好评。',
    time: '2天前',
    likes: 1287,
  },
  {
    id: 5,
    name: '追更急先锋',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20with%20excited%20expression%2C%20warm%20peach%20tones%2C%20soft%20lighting%2C%20Japanese%20illustration%20style%2C%20clean%20background&width=80&height=80&seq=avatar-manga-05&orientation=squarish',
    content: '更新速度真的快！而且每次更新都有推送提醒，追更再也不用自己每天去刷了。夏季阅读季活动也很良心，签到送的时长够我看好多话了。',
    time: '3天前',
    likes: 996,
  },
];

export const topicItems = [
  { id: 1, name: '星界旅人', count: '328万', color: 'accent' },
  { id: 2, name: '下拉阅读', count: '256万', color: 'primary' },
  { id: 3, name: '暗影猎手', count: '212万', color: 'secondary' },
  { id: 4, name: '恋爱这件小事', count: '189万', color: 'accent' },
  { id: 5, name: '机械纪元', count: '167万', color: 'primary' },
  { id: 6, name: '苍穹之下', count: '145万', color: 'secondary' },
  { id: 7, name: '异世界转生', count: '132万', color: 'accent' },
  { id: 8, name: '热血少年漫', count: '118万', color: 'primary' },
  { id: 9, name: '悬疑推理', count: '103万', color: 'secondary' },
  { id: 10, name: '夏季阅读季', count: '97万', color: 'accent' },
];

export const indexItems = [
  { id: 1, title: '热血格斗', desc: '燃爆肾上腺素的战斗盛宴', count: '856部', icon: 'ri-sword-line' },
  { id: 2, title: '恋爱甜宠', desc: '心跳加速的甜蜜物语', count: '723部', icon: 'ri-heart-line' },
  { id: 3, title: '悬疑推理', desc: '烧脑反转的智力较量', count: '541部', icon: 'ri-search-eye-line' },
  { id: 4, title: '搞笑日常', desc: '笑到停不下来的快乐源泉', count: '612部', icon: 'ri-emotion-happy-line' },
  { id: 5, title: '奇幻冒险', desc: '异世界穿越的无限想象', count: '489部', icon: 'ri-compass-3-line' },
  { id: 6, title: '科幻未来', desc: '科技与未来的震撼视觉', count: '376部', icon: 'ri-rocket-line' },
  { id: 7, title: '恐怖惊悚', desc: '深夜独自挑战的胆量测试', count: '298部', icon: 'ri-ghost-line' },
  { id: 8, title: '古风国漫', desc: '国风之美的新生力量', count: '267部', icon: 'ri-brush-line' },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '星界旅人', author: '星辰大海', heat: '328万', trend: 'up', change: '+2' },
  { id: 2, rank: 2, title: '暗影猎手', author: '墨色清晨', heat: '296万', trend: 'up', change: '+1' },
  { id: 3, rank: 3, title: '机械纪元', author: '铁甲依然在', heat: '254万', trend: 'down', change: '-1' },
  { id: 4, rank: 4, title: '苍穹之下', author: '云端漫步', heat: '198万', trend: 'up', change: '+3' },
  { id: 5, rank: 5, title: '恋爱这件小事', author: '糖心风暴', heat: '176万', trend: 'stable', change: '0' },
];

export const featureItems = [
  {
    id: 1,
    title: '下拉式连续阅读',
    desc: '滚动代替翻页，漫画阅读从未如此流畅。所有章节无缝衔接，沉浸感倍增。',
    icon: 'ri-scroll-to-bottom-line',
  },
  {
    id: 2,
    title: '智能预加载缓存',
    desc: '提前缓存后续章节，弱网环境也能保持丝滑阅读体验，地铁通勤必备。',
    icon: 'ri-download-cloud-2-line',
  },
  {
    id: 3,
    title: '跨设备进度同步',
    desc: '手机、平板、电脑随心切换，阅读进度自动同步，走到哪看到哪。',
    icon: 'ri-device-line',
  },
  {
    id: 4,
    title: '海量正版资源',
    desc: '覆盖热血、恋爱、悬疑、奇幻等全品类漫画，日更百话，总有你想看的。',
    icon: 'ri-stack-line',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '汗汗漫画的下拉式阅读和普通翻页有什么区别？',
    answer: '下拉式阅读将整部漫画的所有章节连接成一个连续的滚动流，您只需向下滑动即可无缝阅读，无需点击"下一话"按钮等待加载。这种方式极大减少了阅读中断，让分镜之间的节奏感更流畅，特别适合战斗场景和连续叙事。',
  },
  {
    id: 2,
    question: '是否需要注册账号才能阅读漫画？',
    answer: '不需要。汗汗漫画支持游客直接阅读，打开即看。注册账号可以解锁跨设备进度同步、收藏追更、阅读历史等高级功能，让您的阅读体验更加个性化。',
  },
  {
    id: 3,
    question: '漫画更新频率是怎样的？',
    answer: '平台每日更新超过100话热门连载内容。热门作品通常保持每周1-2话的更新节奏，部分爆款作品可能会加更。您可以在「更新快讯」模块查看每日最新的更新动态。',
  },
  {
    id: 4,
    question: '支持离线阅读吗？',
    answer: '支持！汗汗漫画的智能预加载技术会自动缓存您正在阅读的漫画后续章节。在网络良好的环境下打开漫画后，即使进入弱网或无网环境（如地铁、电梯），已缓存的内容依然可以流畅阅读。',
  },
  {
    id: 5,
    question: '如何在手机和电脑之间同步阅读进度？',
    answer: '注册账号后，您的阅读进度、收藏列表和阅读历史会自动云端同步。在手机上看到一半的漫画，打开电脑版可以无缝从中断处继续，不需要手动记录章节。',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '《星界旅人》——星际冒险的巅峰之作',
    desc: '穿越银河系的壮阔旅程，每一帧都是壁纸级别的精致画面。下拉连续阅读时，星际战斗的宏大场面更加震撼。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20space%20adventure%20manga%20illustration%20with%20starships%20and%20galaxies%2C%20Japanese%20sci-fi%20art%20style%2C%20warm%20orange%20and%20gold%20accents%2C%20clean%20composition%2C%20editorial%20quality%2C%20soft%20cosmic%20lighting&width=400&height=280&seq=card-manga-01&orientation=landscape',
    tag: '科幻',
    reads: '1.2亿',
  },
  {
    id: 2,
    title: '《暗影猎手》——暗黑世界的正义之光',
    desc: '潜伏于黑暗中的猎手，用手中的利刃守护人间。悬疑与动作的完美结合，下拉阅读节奏由你掌控。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20urban%20fantasy%20manga%20illustration%20with%20shadowy%20hunter%20character%2C%20Japanese%20seinen%20style%2C%20warm%20amber%20and%20deep%20orange%20tones%2C%20dramatic%20lighting%2C%20clean%20editorial%20composition&width=400&height=280&seq=card-manga-02&orientation=landscape',
    tag: '悬疑',
    reads: '9800万',
  },
  {
    id: 3,
    title: '《恋爱这件小事》——甜到心坎的校园物语',
    desc: '青涩的暗恋，笨拙的表白，每一话都是青春的印记。下拉滚动间，那些心动的瞬间仿佛就发生在昨天。',
    image: 'https://readdy.ai/api/search-image?query=Sweet%20school%20romance%20manga%20illustration%20with%20cherry%20blossoms%2C%20Japanese%20shojo%20style%2C%20soft%20warm%20peach%20and%20cream%20tones%2C%20gentle%20lighting%2C%20clean%20editorial%20composition&width=400&height=280&seq=card-manga-03&orientation=landscape',
    tag: '恋爱',
    reads: '8600万',
  },
  {
    id: 4,
    title: '《机械纪元》——人与机器的终极对决',
    desc: '在高度机械化的未来世界，人类的情感是最后的武器。下拉阅读时，机械战斗的速度感扑面而来。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20mecha%20manga%20illustration%20with%20giant%20robots%2C%20Japanese%20sci-fi%20style%2C%20warm%20copper%20and%20orange%20tones%2C%20dynamic%20composition%2C%20editorial%20quality%2C%20soft%20industrial%20lighting&width=400&height=280&seq=card-manga-04&orientation=landscape',
    tag: '科幻',
    reads: '7400万',
  },
  {
    id: 5,
    title: '《苍穹之下》——天空国度的奇幻史诗',
    desc: '漂浮在云层之上的神秘大陆，少年踏上了寻找失落文明的冒险之旅。下拉滚动间，奇幻世界徐徐展开。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20sky%20world%20manga%20illustration%20with%20floating%20islands%2C%20Japanese%20adventure%20style%2C%20warm%20golden%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20clean%20editorial%20composition&width=400&height=280&seq=card-manga-05&orientation=landscape',
    tag: '奇幻',
    reads: '6200万',
  },
  {
    id: 6,
    title: '《妖兽都市》——现代都市的妖怪传说',
    desc: '隐藏在钢筋水泥森林中的妖怪世界，普通人看不见的精彩故事每天都在上演。下拉阅读，沉浸式体验都市奇幻。',
    image: 'https://readdy.ai/api/search-image?query=Urban%20fantasy%20manga%20illustration%20with%20mythical%20creatures%20in%20modern%20city%2C%20Japanese%20supernatural%20style%2C%20warm%20coral%20and%20cream%20tones%2C%20atmospheric%20lighting%2C%20clean%20editorial%20composition&width=400&height=280&seq=card-manga-06&orientation=landscape',
    tag: '奇幻',
    reads: '5800万',
  },
];

export const contactInfo = {
  title: '联系我们',
  desc: '商务合作、内容投稿、问题反馈，欢迎通过以下方式与我们取得联系。汗汗漫画期待与更多优秀的漫画创作者和内容伙伴携手，共同为读者带来更好的阅读体验。',
  email: 'contact@hanhanmanga.com',
  wechat: 'hanhanmanga_official',
};

export const appInfo = {
  title: 'APP下载',
  desc: '下载汗汗漫画移动客户端，随时随地享受下拉式连续阅读的流畅体验。支持 iOS 与 Android 双平台，更有独家离线缓存和推送提醒功能。',
  features: ['下拉连续阅读', '智能离线缓存', '跨设备同步', '更新即时推送'],
};